import {
    Button,
    HStack,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
} from '@chakra-ui/react';

export interface InvoiceTeachExtractionPromptModalProps {
    isOpen: boolean;
    onClose: () => void;
    fieldLabel: string;
    extractedValue: string;
    correctedValue: string;
    vendorName: string;
    invoiceTypeLabel: string;
    isLoading?: boolean;
    /** Tax and grand total hints name the printed line. The dollar amount is not reused. */
    amountLocationHint?: boolean;
    onConfirm: () => void;
}

const InvoiceTeachExtractionPromptModal = ({
    isOpen,
    onClose,
    fieldLabel,
    extractedValue,
    correctedValue,
    vendorName,
    invoiceTypeLabel,
    isLoading = false,
    amountLocationHint = false,
    onConfirm,
}: InvoiceTeachExtractionPromptModalProps) => (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
        <ModalOverlay />
        <ModalContent>
            <ModalHeader fontSize="xl" fontWeight="bold" color="gray.900">
                Should AI remember this correction?
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={4}>
                <Text fontSize="md" color="gray.700" mb={3}>
                    You changed {fieldLabel} from <strong>{extractedValue || '(empty)'}</strong> to{' '}
                    <strong>{correctedValue || 'empty'}</strong>.
                </Text>
                <Text fontSize="md" color="gray.600">
                    {amountLocationHint
                        ? 'PartBay can save a hint for which printed line to read on future '
                        : 'PartBay can analyze this invoice and save a hint for future '}
                    <strong>{vendorName}</strong> <strong>{invoiceTypeLabel}</strong> invoices
                    {amountLocationHint
                        ? '. The dollar amount itself is not reused.'
                        : ' so extraction finds the right value next time.'}
                </Text>
            </ModalBody>
            <ModalFooter>
                <HStack spacing={3}>
                    <Button size="action" variant="outlineGray" onClick={onClose} isDisabled={isLoading}>
                        Not now
                    </Button>
                    <Button
                        size="action"
                        bg="#0071E3"
                        color="white"
                        _hover={{ bg: '#3544a0' }}
                        onClick={onConfirm}
                        isLoading={isLoading}
                    >
                        Remember this
                    </Button>
                </HStack>
            </ModalFooter>
        </ModalContent>
    </Modal>
);

export default InvoiceTeachExtractionPromptModal;
